import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-confirmdialog',
  templateUrl: './confirmdialog.component.html',
  styleUrls: ['./confirmdialog.component.scss']
})
export class ConfirmdialogComponent implements OnInit {

  ngOnInit() {
    console.log("init message : "+this.message);
  }

  message: string = '';
  title: string = '';

  constructor(public dialogRef: MatDialogRef<ConfirmdialogComponent>, @Inject(MAT_DIALOG_DATA) public data: any) {
    this.message = data.message;
    this.title = data.title;
    console.log("message : "+this.message);
  }

  onConfirm(): void {
    this.dialogRef.close(true);  // Ferme le dialogue avec une réponse "confirmée"
  }

  onCancel(): void {
    this.dialogRef.close(false);  // Ferme le dialogue avec une réponse "annulée"
  }
}
